import { ISettingsDataHandler } from '../../data-handlers/settings/ISettingsDataHandler'

export class SettingsRepository {
  handler: ISettingsDataHandler

  constructor(handler: ISettingsDataHandler) {
    this.handler = handler
  }

  async requestSettings(): Promise<{ storeName: string, refreshInterval: number, defaultLanguage: string | null, labelSize: string | null }> {
    return this.handler.requestSettings()
  }
}
